import { render, staticRenderFns } from "./YourMove.vue?vue&type=template&id=4647484b&"
import script from "./YourMove.vue?vue&type=script&lang=js&"
export * from "./YourMove.vue?vue&type=script&lang=js&"
import style0 from "./YourMove.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports